import axios from "axios"
import { HTTP_RESPONSE } from "../../Utility/Helpers/constants"

export const DATA_API_URL = process.env.REACT_APP_API_BASE_URL + 'skucodes'

const SkuSearchRepository = {
  searchSku: async (sku, companyId) => {
    try {
      // Utilise l'endpoint find avec filter sur la propriété sku
      const filter = encodeURIComponent(JSON.stringify({ where: { sku, companyId } }))
      const response = await axios.get(`${DATA_API_URL}/search?filter=${filter}`)
      return response.data
    } catch (e) {
      if (e.response) {
        throw e.response
      } else {
        throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND }
      }
    }
  }
}

export default SkuSearchRepository
